import { Col, Row, Spinner, Table } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Card } from "../components/Card";
import { LinkGen } from "../LinkGen";
import { TrafficChart } from "./TrafficChart";
import {
	useGoogleAnalyticsStatus,
	useGoogleAnalyticsTraffic,
} from "./useGoogleAnalytics";

export const WebsiteTrafficCard = () => {
	const { data: status, isLoading: statusLoading } = useGoogleAnalyticsStatus();

	const connected = status?.connected ?? false;

	const {
		data: traffic,
		isLoading: trafficLoading,
		isError: trafficError,
	} = useGoogleAnalyticsTraffic(connected);

	if (statusLoading) {
		return null;
	}

	if (!connected) {
		return (
			<Card>
				<Card.Header>Website Traffic</Card.Header>
				<Card.Body>
					<p>
						Connect Google Analytics to see your website traffic data.{" "}
						<Link to={LinkGen.Settings.Apps()}>Go to Settings</Link>
					</p>
				</Card.Body>
			</Card>
		);
	}

	if (trafficError) {
		return (
			<Card>
				<Card.Header>Website Traffic</Card.Header>
				<Card.Body>
					<p>
						Unable to load traffic data. Make sure a Google Analytics property
						is selected.{" "}
						<Link to={LinkGen.Settings.Apps()}>Go to Settings</Link>
					</p>
				</Card.Body>
			</Card>
		);
	}

	if (trafficLoading || !traffic) {
		return (
			<Card>
				<Card.Header>Website Traffic</Card.Header>
				<Card.Body className="d-flex justify-content-center py-4">
					<Spinner animation="border" />
				</Card.Body>
			</Card>
		);
	}

	return (
		<Card>
			<Card.Header>
				Website Traffic{" "}
				<span className="text-muted" style={{ fontSize: "0.85em" }}>
					({traffic.totalSessions.toLocaleString()} sessions)
				</span>
			</Card.Header>
			<Card.Body>
				<TrafficChart data={traffic.sessionsByDay} />

				<Row className="mt-4">
					<Col md={6}>
						<h6>Traffic Sources</h6>
						<Table size="sm" striped>
							<thead>
								<tr>
									<th>Channel</th>
									<th className="text-end">Sessions</th>
									<th className="text-end">%</th>
								</tr>
							</thead>
							<tbody>
								{traffic.trafficSources.map((source) => (
									<tr key={source.channel}>
										<td>{source.channel}</td>
										<td className="text-end">
											{source.sessions.toLocaleString()}
										</td>
										<td className="text-end">{source.percentage}%</td>
									</tr>
								))}
							</tbody>
						</Table>
					</Col>
					<Col md={6}>
						<h6>Top Pages</h6>
						<Table size="sm" striped>
							<thead>
								<tr>
									<th>Page</th>
									<th className="text-end">Sessions</th>
									<th className="text-end">%</th>
								</tr>
							</thead>
							<tbody>
								{traffic.topPages.map((page) => (
									<tr key={page.page}>
										<td
											title={page.page}
											style={{
												maxWidth: "200px",
												overflow: "hidden",
												textOverflow: "ellipsis",
												whiteSpace: "nowrap",
											}}
										>
											{page.page}
										</td>
										<td className="text-end">
											{page.sessions.toLocaleString()}
										</td>
										<td className="text-end">{page.percentage}%</td>
									</tr>
								))}
							</tbody>
						</Table>
					</Col>
				</Row>
			</Card.Body>
		</Card>
	);
};
